import { ConfigProvider, Tabs, TabsProps } from "antd";
import styled from "styled-components";
import TabsActiveIcon from "../../assets/images/tabs-active.png";

const TabsWrapper = styled.div`
  background: var(--task-eva-common-card-bg);
  width: 100%;
  height: 100%;
  .ant-tabs.ant-tabs-top {
    height: 100%;
    color: unset;
    .ant-tabs-nav {
      margin-bottom: 0;
      height: 46px;
      &::before {
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }
      // 选中的会自动添加style
      .ant-tabs-ink-bar[style] {
        background: transparent;
        &::after {
          content: " ";
          mask: url(${TabsActiveIcon}) no-repeat 100% 100%;
          mask-size: cover;
          background-color: var(--main-color);
          left: 40%;
          top: -2px;
          width: 24px;
          height: 4px;
          position: absolute;
        }
      }
    }
    .ant-tabs-tab,
    .ant-tabs-tab-active {
      padding: 18px 48px;
      &:hover {
        color: var(--main-color);
      }
    }
    .ant-tabs-tab-btn {
      height: 26px;
    }
    .ant-tabs-tab-active .ant-tabs-tab-btn {
      color: var(--main-color);
      font-weight: 500;
      transition: all 0.5s;
      height: 26px;
    }
    .ant-tabs-tab-btn:focus {
      color: var(--main-color);
    }
    .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
      transition: none;
    }
  }
`;

export interface RenderbusTabsProps extends TabsProps {
  tabsList?: TabsProps["items"];
}

export function Tab(props: RenderbusTabsProps) {
  const { tabsList, items, onChange, ...otherProps } = props;
  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: "#FFFFFF",
        },
      }}
    >
      <TabsWrapper className="renderbus-ui-tab">
        <Tabs onChange={onChange} items={items || tabsList} {...otherProps} />
      </TabsWrapper>
    </ConfigProvider>
  );
}
